import {
  PLACEMENT_ACTION_TYPE,
  type PlacementActionType,
} from "../components/PlacementApplyButton/utils/getPrimaryAction";

/**
 * Action types that require the Job Search Agreement to be signed before proceeding.
 * These are booking-related actions where the worker is demonstrating higher intent.
 */
const BOOKING_ACTION_TYPES: readonly PlacementActionType[] = [
  PLACEMENT_ACTION_TYPE.APPLY,
  PLACEMENT_ACTION_TYPE.BOOK_INTERVIEW,
  PLACEMENT_ACTION_TYPE.TALK_TO_RECRUITER,
  PLACEMENT_ACTION_TYPE.APPLY_VIA_WEBLINK,
] as const;

/**
 * Determines whether the Job Search Agreement modal should be shown before proceeding
 * with a given CTA action.
 *
 * Returns `true` for booking-related actions:
 * - APPLY (includes "Request an interview", "Apply to job", "Join waitlist")
 * - BOOK_INTERVIEW (includes "Book an in-person interview", "Book phone interview", etc.)
 * - TALK_TO_RECRUITER (includes "Unlock instant interviews" screening flow)
 * - APPLY_VIA_WEBLINK (includes "Apply on web" external application flow)
 *
 * Returns `false` for:
 * - Document upload actions (UPLOAD_DOCUMENT, UPLOAD_LICENSE, UPLOAD_CREDENTIAL, etc.)
 * - Reschedule/cancel operations (RESCHEDULE_INTERVIEW, LATE_CANCEL)
 * - Other non-booking actions (VERIFY_ATTENDANCE, etc.)
 *
 * @param actionType - The placement action type from PLACEMENT_ACTION_TYPE
 * @returns Whether the agreement modal should be shown before this action
 */
export function shouldShowAgreementBeforeBooking(actionType: PlacementActionType): boolean {
  if (actionType === undefined) {
    return false;
  }

  return BOOKING_ACTION_TYPES.includes(actionType);
}
